import { Breakpoints } from '../../_common/types/index.js';
import '../../_common/utils/tokensVariants.utils.js';
import { isObject } from '../../_common/utils/common.js';
import { buildAllBreakpointsWithGivenBreakpoints } from '../../_common/utils/buildAllBreakpointsWithGivenBreakpoints.js';
import '../../_common/utils/console.js';
import 'react';
import { getGapStitchesVariants } from '../common/gapProperties/gapProperties.utils.js';
import '../common/gapProperties/gapProperties.styles.js';
const getFlexStitchesVariants = _ref => {
  let {
    centered,
    as,
    gap = 'none'
  } = _ref;
  const isFlexGapAnObject = isObject(gap);
  const isFlexGapResponsive = isFlexGapAnObject && !!Object.keys(gap).find(breakpoint => Breakpoints.includes(breakpoint));
  const gapVariants = isFlexGapResponsive ? Object.assign({}, getGapStitchesVariants(buildAllBreakpointsWithGivenBreakpoints(gap), 'flex')) : Object.assign({}, getGapStitchesVariants(gap, 'flex'));
  return Object.assign({
    as,
    centered
  }, gapVariants);
};
export { getFlexStitchesVariants };